import * as React from 'react';
import { cn } from '@/lib/utils';

export interface ToolbarProps {
  /** Заголовок списка слева: «Найдено 2 046». */
  title?: React.ReactNode;
  /** Середина: обычно <FilterChips>. */
  children?: React.ReactNode;
  /** Справа: сортировка, кнопки. */
  end?: React.ReactNode;
  className?: string;
}

/** Строка над таблицей внутри карточки списка (padding 14/18 как в макете). */
export function Toolbar({ title, children, end, className }: ToolbarProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-2.5 px-[18px] py-3.5', className)}>
      {title && <b className="mr-1.5 font-display text-[17px] font-bold text-text">{title}</b>}
      {children}
      {end && <div className="ml-auto flex flex-wrap items-center gap-2.5 text-[13px] text-text-2">{end}</div>}
    </div>
  );
}
